<div class="row">
  <div class="col-12" style="margin: auto">
    <mat-card class="bg-acyellow pt-4 mb-2" *ngIf="!noTranslate">
      <h1 *ngIf="title$ | async as title">
        {{ title | translated }}
      </h1>
      <h2 *ngIf="title_secondary$ | async as title_secondary">
        {{ title_secondary | translated }}
      </h2>
      <h2 *ngIf="title_third$ | async as title_third">
        {{ title_third | translated }}
      </h2>
    </mat-card>
    <mat-card class="bg-acyellow mb-2" *ngIf="noTranslate">
      <h1 *ngIf="title$ | async as title">
        {{ title }}
      </h1>
      <h2 *ngIf="title_secondary$ | async as title_secondary">
        {{ title_secondary }}
      </h2>
      <h2 *ngIf="title_third$ | async as title_third">
        {{ title_third }}
      </h2>
    </mat-card>
  </div>
</div>
